<template>
  <div class="chart-container">
    <canvas ref="radarChart"></canvas>
  </div>
</template>

<script>
import { Chart } from "chart.js";

export default {
  name: "RadarGraph",
  props: {
    datasets: {
      type: Array,
      required: true,
    },
    labels: {
      type: Array,
      required: true,
    },
    legendPosition: {
      type: String,
      default: "right",
    },
    legendAlign: {
      type: String,
      default: "center",
    },
    legendDisplay: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    this.renderChart();
  },
  watch: {
    datasets: "renderChart",
    labels: "renderChart",
  },
  methods: {
    renderChart() {
      if (this.$data._chart) {
        this.$data._chart.destroy();
      }

      this.$data._chart = new Chart(this.$refs.radarChart, {
        type: "radar",
        data: {
          labels: this.labels,
          datasets: this.datasets.map((dataset, index) => ({
            ...dataset,
            backgroundColor: this.getBackgroundColor(index),
            borderColor: this.getBorderColor(index),
            borderWidth: 1,
            pointBackgroundColor: this.getBackgroundColor(index),
            pointBorderColor: this.getBorderColor(index),
          })),
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            r: {
              angleLines: {
                display: true,
              },
              suggestedMin: 0,
              suggestedMax: 100,
              ticks: {
                beginAtZero: true,
              },
            },
          },
          elements: {
            line: {
              tension: 0.1,
            },
          },
          legend: {
            display: this.legendDisplay,
            position: this.legendPosition,
            align: this.legendAlign,
          },
        },
      });
    },
    getBackgroundColor(index) {
      const colors = [
        "rgba(54, 162, 235, 0.2)",
        "rgba(255, 99, 132, 0.2)",
        "rgba(255, 206, 86, 0.2)",
        "rgba(75, 192, 192, 0.2)",
        "rgba(153, 102, 255, 0.2)",
        "rgba(255, 159, 64, 0.2)",
      ];
      return colors[index % colors.length];
    },
    getBorderColor(index) {
      const colors = [
        "rgba(54, 162, 235, 1)",
        "rgba(255, 99, 132, 1)",
        "rgba(255, 226, 106, 1)",
        "rgba(75, 192, 192, 1)",
        "rgba(153, 102, 255, 1)",
        "rgba(255, 159, 64, 1)",
      ];
      return colors[index % colors.length];
    },
  },
};
</script>

<style scoped>
.chart-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}
</style>
